import { Component, OnInit } from "@angular/core";
import { DecimalPipe } from "@angular/common";

import { Plan } from "../../../shared/models/plan.model";
import { DirectSessionLogicService } from "../../../shared/direct-session-logic.service";

import { FormContactInfoConfirmationComponent } from "./form-contact-confirmation/form-contact-confirmation.component";
import { environment } from "../../../../environments/environment";

@Component({
    selector: 'app-form-textBox',
    template:`
    <div class="overview-header">
        <img src="assets/Icons/shield-check-purple.svg" alt="" class="overview-header-icon">
        <div>
            <h3 class="overview-title">You're One Step Away From Protection</h3>
            <p class="overview-subtitle">Review your information and complete checkout to activate your {{companyName}} membership.</p>
        </div>
    </div>

    <div class="selected-plan-card">
        <div class="selected-plan-label">Selected Plan</div>
        <div class="selected-plan-name">{{plan.name}}</div>
        <div class="selected-plan-price">
            @if(discountIsVisible){
                <span class="selected-plan-price-original">\${{plan.price}}</span>
                <span class="selected-plan-price-discounted">\${{totalCost | number:'1.2-2'}} / month</span>
            } @else {
                \${{plan.price}} / month
            }
        </div>
    </div>

    <h5 class="overview-section-title">What Happens Next</h5>
    <div class="overview-steps">
        @for(nextStep of whatHappensNext; track nextStep.title; let i = $index){
            <div class="overview-step">
                <div class="overview-step-number">{{i + 1}}</div>
                <div class="overview-step-content">
                    <div class="overview-step-title">{{nextStep.title}}</div>
                    <div class="overview-step-body">{{nextStep.body}}</div>
                </div>
            </div>
        }
    </div>

    <app-form-contact-confirmation></app-form-contact-confirmation>
    `,
    styleUrls: ['./form-textBox.component.scss'],
    standalone: true,
    imports: [ FormContactInfoConfirmationComponent, DecimalPipe ],

})
export class FormTextBoxComponent implements OnInit{

    companyName: string = environment.CompanyInfo.CompanyName.toString();

    whatHappensNext = [
        {
            title: "Confirmation email sent immediately",
            body: "You'll receive a payment confirmation email right away with your membership details."
        },
        {
            title: "Enrollment email arrives within 24 hours",
            body: "You'll receive instructions to create your online account and start protecting your identity."
        },
        {
            title: "Create your account and activate monitoring",
            body: "Add the information you'd like to monitor and customize your protection settings."
        },
        {
            title: "Setup guide mailed to the address on file",
            body: "A helpful setup guide with tips and resources will be mailed to the address on file."
        }
    ];

    constructor(
        public directSessionLogic: DirectSessionLogicService
    ){
        this.escapeCheck();
    }

    get plan(): Plan {
        return this.directSessionLogic.planSelectedSignal();
    }

    // Mirror the Order Summary: show the discounted total when a promo is applied
    get totalCost(): number {
        return this.directSessionLogic.trimmedSessionSignal().totalCost;
    }

    get discountIsVisible(): boolean {
        return (this.directSessionLogic.returnDiscount() ?? 0) > 0;
    }

    ngOnInit(){
        this.escapeCheck();
    }

    escapeCheck(){
        if(this.directSessionLogic.planSelectedSignal().name === undefined || this.directSessionLogic.planSelectedSignal().name === null) {
            console.log("no plan selected, escaping to top level");
            this.directSessionLogic.escapeToTopLevelSignal();
        }else{
            this.directSessionLogic.completeCurrentPage();
        }
    }

}
